import {ArrowBackRounded} from '@mui/icons-material';
import {Box, Button, Stack} from '@mui/material';
import './guest.css'

const GuestBase = ({children, onPrev, onNext}) => (
  <Stack direction="column" height="100vh" width="100vw" alignItems="stretch" className='guest-base'>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        p: 1,
      }}
    >
      <Button sx={{ml: 1.5, textTransform: 'none'}} startIcon={<ArrowBackRounded />} onClick={onPrev}>
        Back
      </Button>
    </Stack>
    <Stack direction="row" alignItems="center" justifyContent="center" sx={{overflow: 'scroll'}}>
      <Box sx={{maxWidth: 'sm', maxHeight: '100%'}}>{children}</Box>
    </Stack>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        p: 2,
      }}
    >
      <Box sx={{maxWidth: 'md', minWidth: 270, p: 3}}>
        <Button
          fullWidth
          variant="contained"
          sx={{
            borderRadius: '30px',
            backgroundColor: '#72d8da',
            color: 'white',
            fontSize: '20px',
            p: 1.5,
          }}
          onClick={onNext}
        >
          Continue
        </Button>
      </Box>
    </Stack>
  </Stack>
);

export default GuestBase;
